import { useEffect } from "react";
import { setPageTitle } from "api";

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title;
    setPageTitle(title);
  }, [title]);
};

export default usePageTitle;